import React, {useState} from 'react'
import {motion, AnimatePresence} from 'framer-motion';

import './showDetailProduct.css';
import dataProductLit from '../shwowProductsHome/dataProducts';
import ShowImageDetail from './showImgDetail/showImageDetail';

const ShowDetailProdcut =({dataProduct,modalstate, handleShoppingCart, handleStateViewdDetail, TIENDA})=>{
// console.log('---detail product');
// console.log(dataProduct);

    const [imageActual, setImageActual] = useState(dataProduct.fotoProducto);
    const [moreDetailProduct, setMoreDetailProduct] = useState(false);
    const [moreOpcionDetail, setMoreOpcionDetail] = useState("description")

    const [stateImgDetail, setStateImgDetail]= useState(false);

    const showImgDetail = () =>{
        setStateImgDetail(!stateImgDetail)
    }

    const handleChangeImage=(srcImage)=>{
        // console.log(srcImage);
        if(srcImage){
            setImageActual(srcImage)
        }
    }

    // temporales
    const cardBody ={
        _id:"608b36ff55fb720b783d8d10",
        colorsAvailable:"color de la foto",
        envioDesde:"potosi",
        tipoEnvio:"gratuito",
        estadoProduct:"nuevo",
        idNegocio:"608b33b655fb720b783d8d08",
        nameProduct:"luxury business gifts gaming headset for airpods max air pod earphone case carbon fiber-1",
        nameTienda:"tecno mundo",
        preceBefore:160,
        preceCurrent:155,
        costoEnvio:0,
        piezasDiponibles:40,
        marcaproduct:"Luxury",
        descripcion:"We hate to break it to youbut you Air Pods Max is not immuneto scratches, nicks, and dents.Thant's why we're here to help.Made in high grade durable real carbon fiberthat ussually used in supercar and space fields.",
        fotoProducto:"https://mybucket-ecommerce2.s3.sa-east-1.amazonaws.com/IMG_1619736319807.jpg",
        fotoProducto2:"https://mybucket-ecommerce2.s3.sa-east-1.amazonaws.com/IMG_1619736335145.jpg",
        fotoProducto3:"https://mybucket-ecommerce2.s3.sa-east-1.amazonaws.com/IMG_1619736344771.jpg",
        fotoProducto4:"https://mybucket-ecommerce2.s3.sa-east-1.amazonaws.com/IMG_1619736354063.jpg"
    }
    // ---example--


    return (
        <div key="detail" id="container-detail-product" className=" rounded-lg  mx-auto my-24">
            <div  className="text-lg bg-white rounded-t-lg font-semibold flex flex-row-reverse " >
                <span onClick={()=>modalstate()} className="hover:text-gray-600 cursor-pointer text-xl font-bold px-2">x</span>
            </div>
            <div id="detail-product" className=" h-full  grid  grid-col-1 chrome sm:grid-cols-2  sm:grid-rows-1">
                <div id="image-view-big"  className=" bg-white pb-6 ">
                    <motion.div key={imageActual} id="image-view-detail" className=" bg-white h-4/5" initial={{opacity:0, x:12}} animate={{opacity:1, x:0}} transition={{ duration: 0.1 }} >
                            {/* <div className="absolute h-full w-full"  style={{backgroundColor:'black',opacity:'0.70'}} /> */}
                            <img onClick={showImgDetail}  src={imageActual}  alt=""  />
                    </motion.div>
                    <ShowImageDetail showImgDetail={showImgDetail} stateImgDetail={stateImgDetail}  urlImage={imageActual} />
                    <div id="images-viwes-small" className="flex flex-row  border-2 border-white">
                        <motion.ul initial={{opacity:0,y:-10}} animate={{opacity:1, y:0}} transition={{duration:0.6}} className="flex flex-row gap-x-2">
                            <motion.li whileHover={{scale:1.01}} whileTap={{scale:1.04}} id="img-muestra" className="h-full">
                                <img onClick={()=>handleChangeImage(dataProduct?.fotoProducto)} src={dataProduct?.fotoProducto}  alt="" width="auto" />
                            </motion.li>
                            <motion.li  whileHover={{scale:1.01}} whileTap={{scale:1.04}} id="img-muestra" className="h-full">
                                <img onClick={()=>handleChangeImage(dataProduct?.fotoProducto2)} src={dataProduct?.fotoProducto2}  alt="" width="auto" />
                            </motion.li>
                            <motion.li whileHover={{scale:1.01}} whileTap={{scale:1.04}} id="img-muestra" className="h-full">
                                <img  onClick={()=>handleChangeImage(dataProduct?.fotoProducto3)} src={dataProduct?.fotoProducto3}  alt="" width="auto" />
                            </motion.li>
                            <motion.li whileHover={{scale:1.01}} whileTap={{scale:1.04}} id="img-muestra" className="h-full">
                                <img onClick={()=>handleChangeImage(dataProduct?.fotoProducto4)} src={dataProduct?.fotoProducto4}  alt="" width="auto" />
                            </motion.li>
                        </motion.ul>
                    </div>
                </div>
        
                <motion.div initial={{opacity:0}} animate={{opacity:1, x:0}}  className=" h-full w-full">
                    <div className="p-3 h-full flex flex-col justify-between ">
                        <div>
                            <div className="text-xl font-bold text-gray-800 capitalize">
                                {dataProduct.nameProduct}
                            </div>
                            <div className="text-gray-500 text-sm pb-2">El vendedor asume toda la responsabilidad sobre este anuncio.</div> 
                            {/* <div className="text-gray-500">Vendedor : <span className="text-indigo-400 capitalize font-bold">{cardBody.nameTienda}</span></div> */}
                            <div className="text-gray-600">Unidades disponibles :  <span className="text-grsy-600 font-semibold">{dataProduct.piezasDiponibles}</span></div>
                            <div className="text-gray-600">Colores disponobles : <span className="text-gray-600 font-semibold">{dataProduct.colorsAvailable}</span></div>
                            <div className="line-through mt-3 text-red-600 font-semibold text-lg">{TIENDA?.country?.currenciesMoneda} {dataProduct.priceBefore}</div>
                            <div className="flex flex-row text-green-600 text-3xl font-bold ">
                               {TIENDA?.country?.currenciesMoneda} {dataProduct.priceCurrent} 
                                <motion.div animate={{scala:[1,2,2,1,1], rotateZ:[0,0,270,270,0]}} className="my-auto ml-3"> 
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </motion.div>
                            </div>
                            <div className="text-gray-400 capitalize">envios desde: <span className="font-semibold">{dataProduct.envioDesde}</span></div>
                            <div className="border border-green-300 rounded-lg inline-block text-gray-500 px-2">Costo de Envio: {dataProduct.costoEnvio} {TIENDA?.country?.currenciesMoneda}</div>
                        </div>
                        
                        <div className="container mb-5">
                            <div id="btn-comprar-ahora" onClick={()=>{handleShoppingCart(dataProduct);modalstate();handleStateViewdDetail()}} className="flex  flex-row my-4 mx-auto rounded-full text-white  cursor-pointer   font-semibold p-2">
                                <div className="flex flex-rows-1 mx-auto">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                                    </svg>
                                    Comprar ahora
                                </div>
                            </div>
                            <div key="add-cart" id="btn-agregar-carrito" onClick={()=>{ handleShoppingCart(dataProduct);modalstate()}} className="flex flex-row my-4 mx-auto rounded-full hover:bg-green-500 cursor-pointer text-white  font-semibold p-2">
                               <div className="flex flex-rows-1 mx-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
                                    </svg>
                                    Agregar al Carrito
                               </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
            <div onClick={()=>setMoreDetailProduct(!moreDetailProduct)} className="rounded-b-lg bg-gray-200 opacity-50 hover:opacity-75  text-center text-basck">
                <svg id="arrow-down-detail-producto" xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mx-auto opacity-100" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 13l-7 7-7-7m14-8l-7 7-7-7" />
                </svg>
            </div>
                <AnimatePresence>
            {
                moreDetailProduct?

                <motion.div exit={{opacity:0,y:-10}} initial={{y:-20}} animate={{y:0}} duration={{motion:2}} className="rounded-b-lg pt-5 py-5 px-5 bg-white">
                    <ul className="flex flex-row gap-4">
                        <li className="cursor-pointer active:text-indigo-600">Descripcion</li>
                        <li className="cursor-pointer opacity-50">Comentarios</li>
                    </ul>
                    <hr className="border-2" />
                    {
                        moreOpcionDetail==="description"?
                        <div className="py-0 pt-2 sm:p-4 ">
                            <div className="text-gray-500">Estado del producto : <span className="font-semibold">{dataProduct.estadoProduct}</span></div>
                            <div className="text-gray-500">Marca : <span className="font-semibold">{dataProduct.marcaproduct}</span></div>
                            
                            <div className="text-gray-500"> Detalle : </div>
                            <textarea id="textarea-detail" type="text" readonly="true"  className="text-gray-600 w-full h-52 focus:outline-none">{dataProduct.descripcion}</textarea>
                        </div>
                        :
                        ''

                    }
                </motion.div>
                :''
            }
                </AnimatePresence>
            <div className="h-20">

            </div>
        </div>
    )
}


export default ShowDetailProdcut;